function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useCallback, useState, useEffect, Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Link } from '@olxbr/ds-web';
import * as Lurker from '../../helpers/lurker';
import { ChevronRight } from '@olxbr/ds-icons';
import { Safety } from "@olxbr/ds-spots";
import { Alert, AlertIcon, AlertBoxChat, AlertIconChat } from './styles';
var SecurityCentralModal = /*#__PURE__*/lazy(function () {
  return import('../SecurityCentralModal');
});
export function AlertBoxMessage(_ref) {
  var idPage = _ref.idPage,
    variant = _ref.variant;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalVisible = _useState2[0],
    setModalVisible = _useState2[1];
  var isMobile = typeof window !== 'undefined' && window.innerWidth < 600;
  useEffect(function () {
    Lurker.viewSecurityCentralBanner(idPage);
  }, [idPage]);
  var handleOpenModal = useCallback(function () {
    Lurker.clickOpenSecurityModal({
      idPage: idPage,
      variant: variant
    });
    setModalVisible(true);
  }, [idPage, variant]);
  var handleCloseModal = useCallback(function () {
    Lurker.clickCloseSecurityModal({
      idPage: idPage,
      variant: variant
    });
    setModalVisible(false);
  }, [modalVisible, variant]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, modalVisible && /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(SecurityCentralModal, {
    isMobile: isMobile,
    isOpen: modalVisible,
    handleCloseModal: handleCloseModal,
    idPage: idPage,
    variant: variant
  })), idPage === 'chat' ? /*#__PURE__*/React.createElement(AlertBoxChat, null, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/React.createElement(AlertIconChat, null, /*#__PURE__*/React.createElement(Safety, {
    size: 58
  })), /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(Text.BodyMedium, {
    display: "inline",
    color: "--color-secondary-130",
    marginBottom: "--spacing-1"
  }, "Duvide de comportamentos suspeitos no chat. Saiba como golpistas est\xE3o agindo."), /*#__PURE__*/React.createElement(Link, {
    onClick: handleOpenModal,
    tag: "button",
    size: "small"
  }, "Ver Dicas OLX de Seguran\xE7a")))) : /*#__PURE__*/React.createElement(Alert, {
    isMobile: isMobile
  }, isMobile ? /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(AlertIcon, null, /*#__PURE__*/React.createElement(Safety, null)), /*#__PURE__*/React.createElement(Text.BodySmall, {
    display: "inline",
    marginLeft: "--spacing-4",
    marginTop: "--spacing-1",
    marginBottom: "--spacing-1",
    color: "--color-secondary-130"
  }, "Saiba como aproveitar o melhor da OLX com seguran\xE7a."), /*#__PURE__*/React.createElement(Link, {
    iconRight: /*#__PURE__*/React.createElement(ChevronRight, null),
    onClick: handleOpenModal,
    tag: "button",
    size: "small",
    underline: true
  })) : /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(AlertIcon, null, /*#__PURE__*/React.createElement(Safety, null)), /*#__PURE__*/React.createElement(Text.BodyMedium, {
    display: "inline",
    marginLeft: "--spacing-4",
    marginTop: "--spacing-2",
    marginBottom: "--spacing-2",
    color: "--color-secondary-130"
  }, "Antes de desapegar, entenda como aproveitar o melhor da OLX com seguran\xE7a."), /*#__PURE__*/React.createElement(Link, {
    onClick: handleOpenModal,
    tag: "button",
    size: "small"
  }, "Ver Dicas OLX de Seguran\xE7a"))));
}
AlertBoxMessage.propTypes = {
  idPage: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired
};
export default AlertBoxMessage;